import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { CardGrafico } from './CardGrafico';
import { useChartTheme } from './ChartTheme';
import { fmtBRL } from './formatadores';
import type { DashboardFinanceiro } from '../../types';

export function GraficoTipoReceita({ dados }: { dados: DashboardFinanceiro['contratuais_sucumbencia'] }) {
  const t = useChartTheme();
  const data = [
    { nome: 'Contratuais', valor: dados.contratuais, cor: t.contratuais },
    { nome: 'Sucumbência', valor: dados.sucumbencia, cor: t.sucumbencia },
  ];
  const vazio = data.every((d) => d.valor <= 0);
  return (
    <CardGrafico titulo="Contratuais × Sucumbência" vazio={vazio}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} dataKey="valor" nameKey="nome" outerRadius="80%" stroke="none" label={false}>
            {data.map((d, i) => <Cell key={i} fill={d.cor} />)}
          </Pie>
          <Tooltip
            formatter={(v: number, n) => [fmtBRL(v), n as string]}
            contentStyle={{ background: t.tooltipBg, border: `1px solid ${t.grid}`, borderRadius: 8, fontSize: 12, color: t.texto }}
          />
          <Legend wrapperStyle={{ fontSize: 12, color: t.texto }} />
        </PieChart>
      </ResponsiveContainer>
    </CardGrafico>
  );
}
